<template>
    <div :class="cardClasses" @click="$emit('click')">
        <div class="card h-100">
            <div class="card-body">
                <!-- Ícone no canto superior esquerdo -->
                <div class="icone-container">
                    <IconeSvg :nome="icone" />
                </div>

                <!-- Nome do artefato centralizado -->
                <div class="nome-container">
                    <h6 class="mb-0 text-center nome-artefato" v-html="formatarNome(nmModelo)"></h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconeSvg from '@/components/IconeSvg.vue'

    export default {
        name: 'CardArtefatoGeral',
        components: { IconeSvg },
        props: {
            nmModelo: {
                type: String,
                required: true,
            },
            icone: {
                type: String,
                default: '',
            },
            ativo: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            cardClasses() {
                const classes = ['col', 'item-artefato', 'item-artefato-primary']
                if (this.ativo) {
                    classes.push('item-artefato-ativo')
                }
                return classes.join(' ')
            },
        },
        methods: {
            formatarNome(nome) {
                if (nome === 'Mapa de Risco') return 'Mapa de<br>Risco'
                return nome
            },
        },
    }
</script>


<style scoped>
    .item-artefato {
        position: relative;
        cursor: pointer;
        height: 6.45rem;
        width: 240px;
        flex: 0 0 240px;
    }

        .item-artefato .card {
            position: relative;
            background-color: inherit;
            border: 2px solid #10B981; /* default = success (será sobrescrito pelas classes abaixo) */
            padding: 0.4rem;
            height: 100%;
            display: flex;
            flex-direction: column;
            transition: transform .2s ease, box-shadow .2s ease, border-color .3s ease, background .3s ease;
            border-radius: 16px;
        }

    /* Layout do card */
    .card-body {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 0.75rem;
        height: 100%;
        padding: 0.5rem 0.8rem;
    }

    /* Nome centralizado */
    .nome-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        min-height: auto;
        text-align: center;
    }

    /* Área dedicada para o ícone à esquerda */
    .icone-container {
        position: static;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 2.2rem;
        flex-shrink: 0;
        border-radius: 50%;
        background-color: rgba(59, 130, 246, 0.15);
    }

        .icone-container svg {
            width: 1.3rem;
            height: 1.3rem;
            opacity: 0.9;
        }

    .nome-artefato {
        font-size: 0.85rem;
        font-weight: 600;
        line-height: 1.2;
        word-break: break-word;
        overflow-wrap: anywhere;
        hyphens: auto;
        white-space: normal;
        overflow-wrap: break-word;
        padding-right: 30px;
    }

    /* Informações na parte inferior */
    .info-container {
        position: absolute;
        bottom: 0.1rem;
        left: 0.3rem;
        right: 0.3rem;
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
        padding-right: 1.8rem; /* espaço reservado para o status-indicator */
    }

    .info-item {
        font-size: 0.85rem;
        line-height: 1.1;
        display: flex;
        align-items: center;
        overflow: hidden;
    }

        .info-item small {
            display: flex;
            align-items: center;
            max-width: 100%;
            min-width: 0;
            white-space: nowrap;
            gap: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
        }

            .info-item small span {
                display: inline-block;
                min-width: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

        .info-item i {
            font-size: 0.6rem;
            opacity: 0.8;
        }

    /* Status indicator no canto inferior direito */
    .status-indicator {
        position: absolute;
        bottom: 0.3rem;
        right: 0.3rem;
        z-index: 2;
    }

    /* ESTILO AZUL FIXO */
    .item-artefato-primary .card {
        background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
        border-color: #3B82F6;
        color: #1D4ED8;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.18);
    }

    [data-bs-theme="dark"] .item-artefato-primary .card {
        background: linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%);
        border-color: #60A5FA;
        color: #bfdbfe;
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
    }

    .item-artefato-primary .card *,
    .item-artefato-primary .card svg {
        color: inherit;
        fill: currentColor;
    }

    /* Hovers */
    .item-artefato:hover {
        z-index: 1002;
        position: relative;
    }

    .item-artefato-primary:hover .card {
        transform: scale(1.02);
        box-shadow: 0 6px 18px rgba(59, 130, 246, 0.25);
    }

    /* ESTADO ATIVO - Card selecionado */
    .item-artefato-ativo .card {
        background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%) !important;
        border-color: #1D4ED8 !important;
        border-width: 3px !important;
        color: #FFFFFF !important;
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4), 0 0 0 4px rgba(59, 130, 246, 0.15) !important;
        animation: pulseActive 0.4s ease-out;
    }

    .item-artefato-ativo .card *,
    .item-artefato-ativo .card svg {
        color: #FFFFFF !important;
        fill: #FFFFFF !important;
    }

    .item-artefato-ativo .icone-container {
        background-color: rgba(255, 255, 255, 0.25) !important;
    }

    [data-bs-theme="dark"] .item-artefato-ativo .card {
        background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%) !important;
        border-color: #60A5FA !important;
        color: #E0E7FF !important;
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5), 0 0 0 4px rgba(96, 165, 250, 0.2) !important;
    }

    [data-bs-theme="dark"] .item-artefato-ativo .card *,
    [data-bs-theme="dark"] .item-artefato-ativo .card svg {
        color: #E0E7FF !important;
        fill: #E0E7FF !important;
    }

    [data-bs-theme="dark"] .item-artefato-ativo .icone-container {
        background-color: rgba(224, 231, 255, 0.25) !important;
    }

    /* Animação ao clicar/selecionar */
    @keyframes pulseActive {
        0% {
            transform: scale(1);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.18);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 8px 24px rgba(59, 130, 246, 0.35);
        }
        100% {
            transform: scale(1);
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4), 0 0 0 4px rgba(59, 130, 246, 0.15);
        }
    }


    /* Responsividade para mobile */
    @media (max-width: 768px) {
        .item-artefato {
            width: 220px;
            flex: 0 0 220px;
            height: 5.5rem;
        }

        .nome-artefato {
            font-size: 0.75rem;
        }

        .info-item {
            font-size: 0.6rem;
        }

        .icone-container svg {
            width: 1rem;
            height: 1rem;
        }
    }
</style>